import { render, staticRenderFns } from "./patient_informations.vue?vue&type=template&id=68841b31&"
import script from "./patient_informations.vue?vue&type=script&lang=js&"
export * from "./patient_informations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports